import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup"

// Define the Yup validation schema
const validationSchema = yup.object({
    username: yup.string().required("User Name is required"),
    password: yup.string().required("Password is required"),
    rememberMe: yup.boolean()
}).required()

export default function Login() {
    const [loading, setLoading] = React.useState('');
    const { login } = useAuth();
    const navigate = useNavigate();

    // Initialize React Hook Form with the Yup resolver
    const { register, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(validationSchema)
    })

    const onSubmit = async (data) => {
        setLoading('loading');
        // Use the data provided by react-hook-form so rememberMe is included
        const success = await login({ username: data.username, password: data.password, rememberMe: !!data.rememberMe });
        setLoading('');
        if (success) {
            // For simplicity, let's just show a message
            alert('Login Successful!');
            // Navigate to protected route or dashboard
            navigate('/');
        } else {
            alert('Login Failed!');
        }
    };

    return (
        <>
            <h3>Login</h3>
            <div className={`row ${loading}`}>
                <div className="col-md-6 col-md-offset-6">
                    <section>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="form-floating mb-2">
                                <input {...register("username")} className="form-control" placeholder="User Name" autoComplete="username" aria-required="true" />
                                <label htmlFor="username" className="form-label">User Name</label>
                                <div>&nbsp; {errors.username && <span className="text-danger">{errors.username.message}</span>}</div>
                            </div>
                            <div className="form-floating mb-2">
                                <input {...register("password")} type="password" className="form-control" autoComplete="current-password" aria-required="true" />
                                <label htmlFor="password" className="form-label">Password</label>
                                <div>&nbsp; {errors.password && <span className="text-danger">{errors.password.message}</span>}</div>
                            </div>
                            <div className="mb-3 form-check">
                                <input id="rememberMe" className="form-check-input" {...register("rememberMe")} type="checkbox" />
                                <label htmlFor="rememberMe" className="form-check-label ps-2">Remember Me</label>
                            </div>
                            <div>
                                <button type="submit" className="w-100 btn btn-lg btn-primary">Log in</button>
                            </div>
                            <div>
                                <p>
                                    <a href="https://example.com/faq.html" target="_blank" rel="noopener noreferrer">
                                        Visit our FAQ
                                    </a>
                                </p>
                                <p>
                                    <Link to="/forgotPassword">Forgot Password</Link>
                                </p>
                                <p>
                                    <Link to="/register">Register</Link>
                                </p>
                            </div>
                        </form>
                    </section>
                </div>
                {loading && <div className='overlay'></div>}
            </div>
        </>
    );
}